<template>
    <transition name="layout-fade">
        <loader v-if="loader"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Статистика (<span :class="status ? 'waiting' : 'executed'">{{ status ? 'Ждет отправки' : 'Выполнен' }}</span>)
                </v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" @click="closeLayout">Закрыть</v-btn>
                <v-btn color="error" class="v-btn--save" @click="dialog = true">Удалить</v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        v-model="push.title"
                        single-line
                        text
                        solo
                        readonly/>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Текст</v-subheader>
                    <v-textarea
                        v-model="push.body"
                        text
                        solo
                        single-line
                        readonly
                        counter="140"/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Пользователи</v-subheader>
                            <p>{{ parseCustomer(push.customer) }}</p>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Устройства</v-subheader>
                            <p>{{ parseDevice(push.device) }}</p>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Пол</v-subheader>
                            <p>{{ parseSex(push.sex) }}</p>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Возраст</v-subheader>
                            <p>
                                <b>от</b> {{ push.age_start }} <b>до</b> {{ push.age_end }}
                            </p>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Тип</v-subheader>
                            <p>{{ parseType(push.type) }}</p>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs4>
                            <v-subheader class="pa-0">Дата отправки</v-subheader>
                            <p>{{ push.date | formatDate }}, {{ push.time }}</p>
                        </v-flex>
                    </v-layout>
                </v-flex>

                <template v-if="push.statistics">
                    <v-subheader class="pa-0 mt-3 mb-3 headline">Статистика</v-subheader>
                    <v-flex xs12>
                        <v-layout>
                            <v-flex xs4>
                                <v-subheader class="pa-0">Количество отправок</v-subheader>
                                <p>{{ push.statistics.send_count }}</p>
                            </v-flex>
                            <v-spacer/>
                            <v-flex xs4>
                                <v-subheader class="pa-0">Пользователей увидело</v-subheader>
                                <p>{{ push.statistics.view_customers }}</p>
                            </v-flex>
                            <v-spacer/>
                            <v-flex xs4>
                                <v-subheader class="pa-0">Из них зарегистрировано</v-subheader>
                                <p>{{ push.statistics.view_customers_reg }}</p>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12>
                        <v-layout>
                            <v-flex xs4>
                                <v-subheader class="pa-0">Устройств</v-subheader>
                                <p>{{ push.statistics.view_ios + push.statistics.view_android }}</p>
                            </v-flex>
                            <v-spacer/>
                            <v-flex xs4>
                                <v-subheader class="pa-0">iOs</v-subheader>
                                <p>{{ push.statistics.view_ios }}</p>
                            </v-flex>
                            <v-spacer/>
                            <v-flex xs4>
                                <v-subheader class="pa-0">Android</v-subheader>
                                <p>{{ push.statistics.view_android }}</p>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </template>

            </v-form>
            <v-dialog v-model="dialog" persistent max-width="45%">
                <v-card>
                    <v-card-title class="headline">
                        <h4>Подтверждение удаление</h4>
                    </v-card-title>
                    <v-card-text>
                        Пуш и вся статистика будет удалено! <br/> Вы уверены что хотите этого?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <template v-if="waitDelete">
                            <v-progress-linear indeterminate color="warning" class="mb-0"/>
                        </template>
                        <template v-else>
                            <v-btn color="green" class="v-btn--save" @click="deletePush">
                                Продолжить
                            </v-btn>
                            <v-btn color="error" class="v-btn--save" @click="dialog = false">
                                Отменить
                            </v-btn>
                        </template>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </transition>
</template>

<script>
    import Push from '../../../api/push'
    import Loader from '../../../components/Loader/Layout'

    export default {
        name: 'viewPush',
        components: { Loader },
        data: () => ({
            dialog: false,
            loader: false,
            waitDelete: false,
            push: {
                title: '',
                customer: 0,
                sex: null,
                device: null,
                age_start: null,
                age_end: null,
                date: null,
                time: null,
                statistics: {
                    send_count: 0,
                    view_ios: 0,
                    view_android: 0,
                    view_customers: 0,
                    view_customers_reg: 0
                }
            },
            status: false
        }),
        mounted () {
            this.getPush(this.$route.params.pushId)
        },
        methods: {
            getPush (id) {
                this.loader = true

                Push
                    .getById(id)
                    .then(response => {
                        this.push = response.data.data
                        this.parseStatus(this.push.date, this.push.time)
                    })
                    .catch(error => {
                        this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] })
                        this.$router.push({ name: 'pushRoot' })
                    })
                    .finally(() => this.loader = false)
            },
            parseCustomer (data) {
                return data === 1 ? 'Зарегестрированные' : 'Все'
            },
            parseDevice (data) {
                return data === 0 ? 'Все' : data === 1 ? 'iOs' : 'Android'
            },
            parseSex (data) {
                return data === 0 ? 'Все' : data === 1 ? 'Мужской' : 'Женщины'
            },
            parseType (data) {
                return !data ? 'Свободный' : data === 1 ? 'Скидки' : 'Бонус за регистрацию'
            },
            parseStatus (date, time) {
                const current = new Date().getTime()
                const target = new Date(`${date} ${time}`).getTime()

                this.status = current < target
            },
            closeLayout () {
                this.$router.push({ name: 'pushRoot' })
            },
            deletePush () {
                this.waitDelete = true

                Push
                    .delete(this.push.id)
                    .then(response => {
                        this.$store.commit('deletePush', { id: this.push.id })
                        this.$store.commit('showSnackbar', {
                            text: response.data.data,
                            color: 'success'
                        })
                        this.$router.push({ name: 'pushRoot' })
                    })
                    .catch(error => new Error(error))
                    .finally(() => {
                        this.dialog = false
                        this.waitDelete = false
                    })
            }
        },
        beforeRouteLeave (to, from, next) {
            next()
        },
        beforeRouteUpdate (to, from, next) {
            this.push = this.getPush(to.params.pushId)
            next()
        }
    }
</script>

<style lang="scss">
    @import "../../../assets/styles/colors.scss";

    .waiting {
        color: $stateProgress;
    }

    .executed {
        color: $stateNew;
    }
</style>
